import React, { useState } from 'react'
import i18n from 'i18next'

import QuestionSection from './QuestionSection'
import Select from '../form/Select'
import utils from './utils'

const getTooltip = (hasExistingData) => {
    if (hasExistingData) return i18n.t('translation.existinData')

    return null
}

const QuestionTranslate = ({
    question, locales, isDisabled, defaultLocale, hasExistingData,
}) => {
    const locale = utils.getDeafultLocale(locales, defaultLocale, question)
    const [targetLocale, setTargetLocale] = useState(locale)

    return (
        <table style={{ width: '100%' }} className="question">
            <thead>
                <tr>
                    <th>
                        {i18n.t('translation.base_language')}
                        <br />
                        {locales.find(({ value }) => value === locale)?.label ?? defaultLocale}
                    </th>
                    <th>
                        {i18n.t('translation.target_language')}
                        <br />
                        <Select
                            options={locales}
                            defaultValue={targetLocale}
                            onBlur={({ value }) => { setTargetLocale(value) }}
                        />
                    </th>
                </tr>
            </thead>
            <tbody>
                <QuestionSection
                    question={question}
                    defaultLocale={locale}
                    targetLocale={targetLocale}
                    isDisabled={isDisabled}
                    tooltip={getTooltip(hasExistingData)}
                />
            </tbody>
        </table>
    )
}

export default QuestionTranslate
